import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/searchProjecten'
import type { ProjectenSearch } from '../types/ProjectenSearch'

export { useProjectenSearchStore }

const useProjectenSearchStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<ProjectenSearch['query']>>((set) => ({
  query: initialState.query,
  storeQuery: (query) =>
    set((state) => ({ query: { ...state.query, ...query } })),
}))
